/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ (() => {

document.querySelectorAll(".lvideo").forEach(function (d) {
  return d.addEventListener("click", playVideos);
});
var body = document.body;
function playVideos(e) {
  lvideo(e.currentTarget.dataset.url);
  body.classList.add("lvideo-active");
  var lvideoWrap = document.createElement("DIV");
  lvideoWrap.setAttribute("id", "lvideo-wrap");
  document.body.appendChild(lvideoWrap);
  var wrapper = document.getElementById("lvideo-wrap");
  wrapper.classList.add("active");
  var url = this.dataset.url;
  var startModal = "<span class=\"lvideo-overlay\"></span> <div class=\"lvideo-container\">";
  var finishModal = "<button class=\"lvideo-close\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" fill=\"none\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.0501 15.636C16.6596 15.2455 16.0265 15.2455 15.6359 15.636C15.2454 16.0266 15.2454 16.6597 15.6359 17.0503L20.5857 22L15.6359 26.9497C15.2454 27.3403 15.2454 27.9734 15.6359 28.364C16.0265 28.7545 16.6596 28.7545 17.0501 28.364L21.9999 23.4142L26.9496 28.364C27.3402 28.7545 27.9733 28.7545 28.3639 28.364C28.7544 27.9734 28.7544 27.3403 28.3639 26.9497L23.4141 22L28.3639 17.0503C28.7544 16.6597 28.7544 16.0266 28.3639 15.636C27.9733 15.2455 27.3402 15.2455 26.9496 15.636L21.9999 20.5858L17.0501 15.636Z\" fill=\"white\"/>\n</svg></button></div>";
  if (url.indexOf("youtube") !== -1 || url.indexOf("youtu") !== -1) {
    var ytUrl = [this.dataset.url];
    var i,
      r,
      regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
    for (i = 0; i < ytUrl.length; ++i) {
      r = ytUrl[i].match(regExp);
      //console.log(r[1])

      document.getElementById("lvideo-wrap").innerHTML = "".concat(startModal, "<iframe title=\"YouTube Video\" src='https://www.youtube.com/embed/").concat(r[1], "?rel=0&autoplay=1&mute=0&loop=1&playlist=").concat(r[1], "' frameborder=\"0\" allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>").concat(finishModal);
    }
  } else if (url.indexOf("vimeo") !== -1) {
    var vimeoURL = this.dataset.url;
    var _regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
    var match = vimeoURL.match(_regExp);
    if (match) {
      document.getElementById("lvideo-wrap").innerHTML = "".concat(startModal, "<iframe title=\"Vimeo\" src=\"https://player.vimeo.com/video/").concat(match[2], "?autoplay=1&loop=1\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>").concat(finishModal);
    } else {
      alert("Not a Vimeo!  URL example:\n https://vimeo.com/120206922");
    }
  } else if (url.indexOf("mp4") !== -1 || url.indexOf("m4v") !== -1) {
    document.getElementById("lvideo-wrap").innerHTML = "".concat(startModal, "<video controls loop playsinline autoplay><source src='").concat(this.dataset.url, "' type=\"video/mp4\"></video>").concat(finishModal);
  } else {
    alert("No video link found.");
  }

  // CLOSE MODAL LVIDEO
  document.querySelectorAll(".lvideo-close").forEach(function (d) {
    return d.addEventListener("click", lvideoClose);
  });
  document.querySelectorAll(".lvideo-overlay").forEach(function (d) {
    return d.addEventListener("click", lvideoClose);
  });
  function lvideoClose() {
    body.classList.remove("lvideo-active");
    var wrapper = document.getElementById("lvideo-wrap");
    wrapper.parentNode.removeChild(wrapper);
  }
}

// LAUNCH
function lvideo() {}

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgracewindale"] = self["webpackChunkgracewindale"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/js/app.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/scss/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;